import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ThemeToggle from "../Common/ThemeToggle";

const AuthNavbar: React.FC = () => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed top-0 left-0 right-0 z-50 bg-knack-dark-800 backdrop-blur-[2px]"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-14">
          <Link
            to="/"
            className="text-[var(--color-light)] hover:text-[var(--color-accent)] transition-colors"
          >
            <h1 className="flex items-center">
              <img
                src="/assets/ukti-logo-with-text-white.png"
                alt="Ukti.ai"
                className="h-10 sm:h-12 md:h-12 w-auto object-contain max-w-none"
              />
            </h1>
          </Link>
          <div className="flex items-center">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default AuthNavbar;
